import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Address } from '../../../main/quoting/interfaces/address.interface';
import { CreateGroupService } from 'src/app/main/quoting/create-group/create-group.service';
import { Router } from '@angular/router';
import { takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { GroupDetailsService } from 'src/app/shared/services/groupDetails/group-details.service';
import { EpAppStore } from 'src/app/shared/services/epAppStoreService/epAppStore.service';

@Component({
    selector: 'app-validation-address',
    templateUrl: './validation-address.component.html',
    styleUrls: ['./validation-address.component.scss'],
    standalone: false
})
export class ValidationAddressComponent implements OnInit, OnDestroy {

  isLoadingScreen = false;
  form: FormGroup;

  private unsubscribeAll = new Subject();

  @Input()
  currentAddress: Address;
  @Input()
  groupDetail;

  @Input()
  fromComponent: string;

  @Input()
  uspsAddress: Address;

  @Input()
  isShowValidationPopUp: boolean;

  addressValidationProps: any;
  @Output() changeAddress = new EventEmitter();
  @Output() togglePopup = new EventEmitter();

  constructor(
    private formBuilder: FormBuilder,
    private createGroupService: CreateGroupService,
    private router: Router,
    private groupService: GroupDetailsService,
    private storeService: EpAppStore
  ) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      addressType: 'usps',
    });

    this.currentAddress.address1 = this.currentAddress.address1.toUpperCase();
    this.currentAddress.address2 = this.currentAddress.address2.toUpperCase();
    this.addressValidation();
  }

  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }

  addressValidation() {
    this.createGroupService.addressValidationObj
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe(obj => {
        this.addressValidationProps = obj;
      });
  }

  closePopup() {
    this.isShowValidationPopUp = false;
    if (this.fromComponent === 'groupDetails') {
      this.togglePopup.emit();
    }
  }

  updateAddress() {
    this.isLoadingScreen = true;
    // Select the address based on the chosen option (curr or usps)
    const selectedAddress = this.form.get('addressType').value === 'curr' ? this.currentAddress : this.uspsAddress;
    // Populate address validation props with the selected address details
    this.addressValidationProps.groupAddress1 = selectedAddress.address1 || '';
    this.addressValidationProps.groupAddress2 = selectedAddress.address2 || '';
    this.addressValidationProps.groupCity = selectedAddress.city;
    this.addressValidationProps.groupState = selectedAddress.state;
    this.addressValidationProps.groupZipCode = parseInt(selectedAddress.zip5 + selectedAddress.zip4);
    // **Always use `uspsAddress.county` as the saved county**
    this.addressValidationProps.county = this.uspsAddress.countyName; // Use the validated address county
    this.addressValidationProps.countyName = this.uspsAddress.countyName;
    // Continue the validation process
    if (this.addressValidationProps.groupZipCode.toString().length === 5 ||
      this.addressValidationProps.groupZipCode.toString().length === 9) {
      if (this.fromComponent === 'createGroup') {
        this.groupService.createGroup(this.addressValidationProps)
          .pipe(
            takeUntil(this.unsubscribeAll),
            tap(() => this.isLoadingScreen = false))
          .subscribe((data) => {
            const currentGroup = {
              ...this.groupDetail,
              groupId: data.id,
              countyName: this.uspsAddress.countyName // Always store the `uspsAddress` county name
            };
            this.storeService.set('currentGroup', {
              ...this.storeService.select('currentGroup').value,
              ...currentGroup
            });
            this.storeService.set('currentQuote', {
              ...this.storeService.select('currentGroup').value,
              ...currentGroup
            });
            this.router.navigate(['/main/quoting/initial-quote']);
          });
      }
      if (this.fromComponent === 'groupDetails') {
        // Emit the validated props, but ensure county is from `uspsAddress`
        this.addressValidationProps.county = this.uspsAddress.countyName;
        this.changeAddress.emit(this.addressValidationProps);
      }
    }
  }
}
